module.exports = __webpack_public_path__ + "assets/img/907986eff655e1a77c346f1936099d9f.svg";